import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import { useEffect, useState } from "react"

import { useAuthorizedAxiosClient } from "../../../../common/axios"
import LengthLimitedTextField from "../../../../common/components/LengthLimitedTextField"
import DialogHeader from "../DialogHeader"

export default function CustomPerkDialog({ open, onClose, perk }) {
  const [title, setTitle] = useState("")
  const [titleError, setTitleErrror] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const axios = useAuthorizedAxiosClient()

  function handleSoftClose() {
    onClose()
  }

  function handleTitleChanged(newTitle) {
    setTitle(newTitle)
    setTitleErrror(null)
  }

  function handleAddButtonClicked() {
    setIsLoading(true)

    let axiosPromise
    if (perk) {
      axiosPromise = axios.put(`/crm/api/custom-perk/${perk.id}/`, { title })
    } else {
      axiosPromise = axios.post("/crm/api/custom-perk/", { title })
    }

    axiosPromise
      .then(({ data }) => {
        onClose(data)
        setTitle("")
      })
      .catch(({ response: { data } }) => {
        if (data.title) {
          setTitleErrror(data.title)
        }
      })
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    if (perk) {
      setTitle(perk.title)
    } else {
      setTitle("")
    }
  }, [perk])

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogHeader
        title={`${perk ? "Edit" : "Add"} custom perk`}
        onClose={handleSoftClose}
      />
      <DialogContent>
        <LengthLimitedTextField
          label="Title"
          value={title}
          setValue={handleTitleChanged}
          maxLength={64}
          error={!!titleError}
          helperText={titleError}
          size="medium"
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleSoftClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          loading={isLoading}
          onClick={handleAddButtonClicked}
          disabled={!title || titleError}
        >
          {perk ? "Save" : "Add"}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
